<template>
  <b-container class="wrap-gallery">
    <div class="wrap-content">
      <b-row>
        <b-col
          cols="12"
          md="8"
          lg="10"
          class="col"
        >
          <Title
            main="A D M A N"
            des="GALLERY"
            class="box-title"
          />
        </b-col>
        <b-col
          cols="12"
          md="4"
          lg="2"
          class="col"
        >
          <select
            v-model="selectYear"
          >
            <option
              v-for="(year, i) in listYear"
              :key="i"
              :value="year"
              >
              {{ year }}
            </option>
          </select>
        </b-col>
      </b-row>
      <Nav :year="selectYear" />
      <Loading v-if="isLoading" />
      <div
        v-if="!isLoading && listImg.length > 0"
        class="box-img"
      >
        <ImageCard
          v-for="(img, i) in listImg"
          :key="img.id"
          :imgUrl="img.imgUrl"
          @click.native="clickImg(i)"
        />

        <LightBox
          :images="lightBoxImg"
           ref="lightbox"
          :showThumbs="false"
          :showLightBox="false"
        />
      </div>
      <div
        v-if="!isLoading && listImg.length === 0"
        class="null"
      >
        NO DATA
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState } from 'vuex'
import LightBox from 'vue-image-lightbox'
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

const Loading = () => import('@/components/Loading/List-9')
const Title = () => import('@/components/About/Parts/Title')
const Nav = () => import('./Parts/Nav')
const ImageCard = () => import('./Parts/ImageCard')

export default {
  components: {
    Loading,
    Title,
    Nav,
    ImageCard,
    LightBox
  },

  data () {
    return {
      listYear: [],
      listImg: [],
      selectYear: 2019,
      lightBoxImg: []
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.gallery.isLoading,
      yearGalleries: state => state.gallery.yearGalleries,
      listGallery: state => state.gallery.listGallery
    })
  },

  methods: {
    matchYear (data) {
      if (data) {
        const arr = []

        data.forEach(item => {
          arr.push(item.year)
        })

        const newArr = arr.sort((a, b) => (a < b) ? 1 : -1)

        this.listYear = newArr
      }
    },

    matchList (data) {
      if (data) {
        this.listImg = []
        data.forEach(detail => {
          const splitImg = detail.image.split(',')

          splitImg.forEach((img, i) => {
            if (img) {
              const obj = {
                id: i,
                imgUrl: `https://admanawards.com/storage/app/img/gallery/${img}`
              }

              this.listImg.push(obj)
            }
          })
        })
      }
    },

    clickImg (id) {
      this.$refs.lightbox.showImage(id)
    },

    imgToLightBox (data) {
      if (data) {
        const arr = []

        data.forEach(item => {
          const obj = {
            thumb: '',
            src: item.imgUrl,
            caption: ''
          }

          arr.push(obj)
        })

        this.lightBoxImg = arr
      }
    }
  },

  created () {
    const params = {
      id: '1',
      year: this.selectYear
    }

    if (!this.yearGalleries && !this.listGallery) {
      this.$store.dispatch('gallery/getYear', 1)
      this.$store.dispatch('gallery/getList', params)
    } else {
      this.matchYear(this.yearGalleries)
      this.matchList(this.listGallery)
    }
  },

  watch: {
    yearGalleries (data) {
      this.matchYear(data)
    },

    listGallery (data) {
      this.matchList(data)
    },

    listImg (data) {
      this.imgToLightBox(data)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables.scss';

.wrap-gallery {
  .wrap-content {
    .row {
      .col {
        display: flex;
        align-items: center;

        select {
          width: 100%;
          padding: 6px 50px 6px 12px;
          border-radius: 0;
          border: 1px solid #888;
          background-color: white;
          background-image: url('../../assets/icons/icon-caret-down.png');
          background-repeat: no-repeat;
          background-position: right .7em top 50%, 0 0;
          background-size: 30px auto, 100%;
          font-size: 1.25rem;
        }

        .box-title {
          padding: 22px 0 0 0;
        }
      }
    }

    .box-empty {
      width: 100%;
      height: 500px;
      background: red;
    }

    .box-img {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      column-count: 1;
      padding: 22px 0 7px 0;
      animation: openPage 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;

      @media only screen and (min-width: $break-m) {
        column-count: 3;
      }
    }

    .box-img:nth-child(n + 3) {
      display: block;
    }

    .null {
      margin: 22px 0;
      padding: 150px;
      width: 100%;
      text-align: center;
      font-size: 1.5rem;
      color: #CCC;
      border: 1px dashed #CCC;
    }
  }
}

@keyframes openPage {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}
</style>
